import { observer } from "mobx-react";
import "./index.scss";

import { ReactComponent as Locate } from "../../../../assets/scheme/locate.svg";
import { ReactComponent as Plane } from "../../../../assets/scheme/Plane.svg";

import { ReactComponent as Line } from "../../../../assets/scheme/line.svg";
import { useEffect } from "react";
import { runInAction } from "mobx";
import { FormState } from "../Arrange";
import { changeCoopState } from "../../../../stores/GlobalState";
const HowItWork = observer(
  ({ content, linkblock }: { content: any; linkblock: any }) => {
    // useEffect(() => {
    //   const locates = document.querySelectorAll('.how-work__route-locate')
    //   if (!locates) return

    //   locates?.forEach((l, i) => {
    //     if (!i) {
    //       ;(l as any)?.style.setProperty(
    //         '--text',
    //         JSON.stringify(content.col5.startPoint),
    //       )
    //     }

    //     if (i + 1 == locates.length) {
    //       ;(l as any)?.style.setProperty(
    //         '--text',
    //         JSON.stringify(content.col5.endPoint),
    //       )
    //     }
    //   })
    // }, [])
    return (
      <section className="how-work">
        <div className="things-col__subtitle">{content?.title}</div>
        <div className="how-work__row">
          <div className="how-work__img">
            <img src={content?.img} />
          </div>
          {/* <div className="how-work__col">
          <div className="how-work__col-row">
            <div className="how-work__subcol mr24">
              <div className="how-work__subcol-img">
                <img src={content.col1.img} />
              </div>
              <div className="how-work__subcol-text"> {content.col1.title}</div>
            </div>{' '}
            <div className="how-work__separator"></div>
            <div className="how-work__subcol">
              <img src={content.col2} />
            </div>
          </div>
          <Line className="how-work__line1" />
          <div className="how-work__col-row black">
            <Locate />
            {content.col3}
          </div>
          <div className="how-work__separator vertical"></div>
          <div className="how-work__col-row grey">
            <img src={content.col4.img} />
            {content.col4.title}
          </div>
          <Line className="how-work__line2" />
          <div className="how-work__col-row">
            <div className="how-work__subcol route">
              <div className="how-work__subcol-text"> {content.col5.title}</div>
              <div className="how-work__route">
                <span className="how-work__route-locate"></span>
                <span className="how-work__route-line"></span>
                <span className="how-work__route-locate"></span>
                <span className="how-work__route-line"></span>
                <span className="how-work__route-locate"></span>
                <span className="how-work__route-line"></span>
                <span className="how-work__route-locate final">
                  <Plane />
                </span>
              </div>
            </div>
            <div className="how-work__separator"></div>
            <div className="how-work__subcol last">
              <img src={content.col6} />
            </div>
          </div>
        </div> */}
          <div className="how-work__list">
            <div className="things-arrange__list">
              {content?.list.map((ci: any, i: number) => (
                <div className="things-arrange__item" key={i}>
                  <div className="things-arrange__item-num">{i + 1}</div>
                  <div
                    className="things-arrange__item-text"
                    dangerouslySetInnerHTML={{ __html: ci }}
                  ></div>
                </div>
              ))}
            </div>
            {content.buttonLink.includes("#coop") ? (
              <div
                className="button black"
                onClick={() => {
                  if (
                    [
                      "freight",
                      "mizhnarodnyi-khab",
                      "end2end-dostavka",
                    ].includes(
                      linkblock
                        .replaceAll("/for-you/", "")
                        .replaceAll("/for-business/", "")
                    )
                  ) {
                    runInAction(() => {
                      FormState.link = linkblock
                        .replaceAll("/for-you/", "")
                        .replaceAll("/for-business/", "");
                    });
                  }
                  changeCoopState();
                }}
              >
                {content.buttonTitle}
              </div>
            ) : (
              <a className="button black" href={content.buttonLink}>
                {content.buttonTitle}
              </a>
            )}
          </div>
        </div>
      </section>
    );
  }
);

export default HowItWork;
